import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme, { inputBorderColor: string }>(
  theme => ({
    container: {
      display: 'flex',
      width: '420px'
    },
    highlight: {
      color: theme.palette.secondary[500],
      backgroundColor: 'inherit',
      marginLeft: theme.spacing(0.5)
    },
    inputBaseRoot: ({ inputBorderColor }) => {
      return {
        width: 300,
        '& > fieldset': {
          borderRight: 'none',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderColor: inputBorderColor
        },
        '&:hover fieldset': {
          boxShadow: 'none',
          borderColor: inputBorderColor
        }
      };
    },
    root: ({ inputBorderColor }) => {
      return {
        '&:hover fieldset': {
          boxShadow: 'none',
          borderColor: inputBorderColor
        }
      };
    },
    inputRoot: ({ inputBorderColor }) => {
      return {
        paddingRight: '16px !important',
        width: 247,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        '& > fieldset': {
          borderColor: inputBorderColor,
          borderLeft: 'none'
        }
      };
    },
    selectMenu: {
      '& .MuiList-root': {
        maxWidth: '100%'
      },
      '& .MuiMenuItem-root:hover': {
        backgroundColor: theme.palette.secondary[100]
      }
    },
    popper: {
      width: '421px !important',
      left: '-86px !important',
      '& > div:first-child': {
        boxShadow: theme.shadows[6]
      }
    },
    noOptionsPopper: {
      '&:after': {
        boxShadow: theme.shadows[6],
        borderTop: `1px solid ${theme.palette.primary[200]}`,
        borderLeft: `1px solid ${theme.palette.primary[200]}`,
        borderTopLeftRadius: theme.spacing(0.5),
        content: '""',
        position: 'absolute',
        top: theme.spacing(0.5),
        right: theme.spacing(2),
        width: theme.spacing(1),
        height: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
        transform: 'rotate(45deg)'
      }
    },
    noOptions: {
      boxShadow: theme.shadows[6],
      border: `1px solid ${theme.palette.primary[200]}`,
      borderRadius: theme.spacing(0.5)
    },
    loading: {
      boxShadow: theme.shadows[6],
      border: `1px solid ${theme.palette.primary[200]}`,
      borderRadius: theme.spacing(0.5)
    },
    option: {
      height: '48px'
    },
    '@global': {
      '.MuiAutocomplete-listbox::after': {
        right: '16px',
        left: 'unset'
      },
      '.MuiMenu-paper::before': {
        right: '16px',
        left: 'unset !important',
        borderTopLeftRadius: theme.spacing(0.5)
      }
    }
  })
);

export default createClasses;
